"use client";
import {
  switch_default
} from "./chunk-ECZ3LCTI.mjs";
import {
  useSwitch
} from "./chunk-K534ZJ2B.mjs";
export {
  switch_default as Switch,
  useSwitch
};
